<template>
  <RF-Dialog
    :cpntLargura='"530px"'
    :cpntStatus="statusGeral"
    :cpntOnFecharDialog='pcoEditarVariosFechar'>
    <template slot='titulo'>      
      <div class="dem-nova-titulo">
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        Editar vários
      </div>
    </template>

    <template slot='conteudo'>
      <div class="pco-edi-var">
        <div>
          Seleciona abaixo o status do processo que deseja colocar para todos os {{ cpntTipo }}s:
        </div>

        <App-Select :data-time="time" class="fin-reg-var--pco_item"
          :cpntStatus='campos.pco_item.status'
          :cpntId='campos.pco_item.id'
          :class='campos.pco_item.class'
          :cpntTabIndex='campos.pco_item.tabIndex'
          :cpntNome='campos.pco_item.nome'
          :cpntValue='campos.pco_item.value'
          :cpntMensagem='campos.pco_item.mensagem'
          :cpntMensagemTipo='campos.pco_item.mensagemTipo'
          :cpntDisabled='campos.pco_item.disabled'
          :cpntMostrar='campos.pco_item.mostrar'
          :cpntExplica='campos.pco_item.explica'
          :cpntPlaceholder='campos.pco_item.placeholder'
          :cpntValueRef='campos.pco_item.valueRef'
          :cpntRouter='campos.pco_item.router'
          :cpntMethod='campos.pco_item.method'
          :cpntField='campos.pco_item.field'
          :cpntWhere='campos.pco_item.where'
          :cpntAddButForm='campos.pco_item.addButForm'
          :cpntKeyMostra='campos.pco_item.keyMostra'
          :cpntTipoOrder='campos.pco_item.tipoOrder'
          :cpntOrder='campos.pco_item.order'
          :cpntOptions='campos.pco_item.options'
          :cpntKeyValue='campos.pco_item.keyValue'
          :cpntSearchMinimo='campos.pco_item.searchMinimo'
          :cpntMask='campos.pco_item.mask'
          :cpntOptionInicialNome='campos.pco_item.optionInicialNome'
          :cpntOptionInicialValue='campos.pco_item.optionInicialValue'
          :cpntNewOption='campos.pco_item.newOption'
          
          :cpntOnBuscarOptions='campos.pco_item.onBuscarOptions'
          :cpntOnChange='campos.pco_item.onChange'
          :cpntOnBlur='campos.pco_item.onBlur'
          :cpntOnRealizaBusca='campos.pco_item.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.pco_item.onKeyPressEnter'
          ref="pco_item"
        ></App-Select>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.pco-edi-var {
  text-align: center;
}
  .pco-edi-var > .fin-reg-var--pco_item {
    width: 300px;
    margin: 20px 0px;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntIds: {
        required: true,
        type: Array
      },
      cpntTipo: {
        required: true,
        type: String
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        cod_venda: null,
        campos: {
          pco_item: {
            id: 'fin-reg-var--pco_item',
            status: '',
            nome: '',
            keyValue: 'id_pco_status_item',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.pcoEditarVariosBuscarStatusProcessoSeletor,
            onChange: this.pcoEditarVariosOnChangeValue
          }
        }
      }
    },
    mounted: function () {
    },
    methods: {
      pcoEditarVariosIniciar: function () {
      },
      pcoEditarVariosFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar)
      },
      pcoEditarVariosSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoEditarVariosBuscarStatusProcessoSeletor: function (callback) {
        this.pcoEditarVariosBuscarStatusProcesso((registros) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.pco_item.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }, { aAnd: [
          { m: 'pco_item', f: 'status', o: '=', v: '1' },
          { m: 'pco_item', f: (this.cpntTipo === 'produto' ? 'id_ven_pro' : 'id_ven_ser'), o: '=', v: this.cpntIds[0] }]
        })
      },
      pcoEditarVariosBuscarStatusProcesso: function (callback, where, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEJA 
          queryGet.field = {
            id_ven_pro: { j: { cod_venda: null } },
            id_ven_ser: { j: { cod_venda: null } },
            id: null,
            id_pco_status_item: { j: { nome: { a: 'nome' }, posicao: null } },
            selecionado: null
          }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = where

          // SETA A ORDENAÇÃO QUE DEVE REALIZAR
          queryGet.order = { id_ven_pro: null, id_ven_ser: null, id_pco_status_item_posicao: 'asc' }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/con-processo/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.pcoEditarVariosBuscarStatusProcesso(callback, where, Number(apiSuccess.countAll), registros)
          }, this.pcoEditarVariosSetarStatusGeral)
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.pco_item.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback([])
        } else {
          if (registros.length >= 1) {
            // VERIFICA QUAL É O CODIGO DA VENDA SELECIONADO
            this.cod_venda = (registros[0].id_ven_pro !== '' ? registros[0].id_ven_pro_cod_venda : registros[0].id_ven_ser_cod_venda)
  
            // TRATA OS REGISTROS RECEBIDOS
            for (var indexR in registros) {
              registros[indexR]._alias = (registros[indexR].id_ven_pro !== '' ? registros[indexR].id_ven_pro : registros[indexR].id_ven_ser)
            }
          }

          // RETORNA O VALORES ENCONTRADOS
          callback(registros)
        }
      },
      pcoEditarVariosOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // VERIFICA SE DEVE FAZER ALGUMA COISA COM A ALTERAÇÃO
        switch (indexF[1]) {
          case 'pco_item': 
            this.pcoEditarVariosRealizarAlteracao()
            break
        }
      },
      pcoEditarVariosRealizarAlteracao: function () {
        // PEGA O VALOR SELECIONADO
        var pco_item = (typeof this.campos.pco_item.value === 'string' ? this.campos.pco_item.value : this.campos.pco_item.value.id_pco_status_item)

        // VERIFICA SE TEM UM VALOR VALIDO
        if ([ '', null, undefined ].indexOf(pco_item) === -1) {
          // SETA O WHERE QUE DEVE INICIAR
          var where = { aAnd: [
            { m: 'pco_item', f: 'status', o: '=', v: '1' },

            { aOr: [ { 
              aAnd: [
                { m: 'pco_item',  f: 'id_ven_pro', o: 'in',  v: this.cpntIds.join()  }, 
                { m: 'ven_pro',   f: 'cod_venda', o: '=',   v: this.cod_venda       } 
              ] }, { aAnd: [
                { m: 'pco_item',  f: 'id_ven_ser', o: 'in',  v: this.cpntIds.join()  }, 
                { m: 'ven_ser',   f: 'cod_venda', o: '=',   v: this.cod_venda       }
              ] }
            ] }
          ] }

          // SETA O STATUS QUE DEVE RETORNAR DE CADA REGISTRO
          where.aAnd.push({ m: 'pco_item', f: 'id_pco_status_item', o: '=', v: pco_item })

          // PEGA APENAS OS REGISTROS QUE NÃO ESTÃO SELECIONADOS
          where.aAnd.push({ f: 'selecionado', o: 'isNull' })
  
          // MANDA BUSCAR OS VALORES
          this.pcoEditarVariosBuscarStatusProcesso((registros) => {
            // INICIA O FORMULARIO
            var formData = []

            // PROCURA O REGISTROS QUE DEVE SELECIONAR
            for (var indexR in registros) {
              formData.push({ id: registros[indexR].id })
            }
            
            // VERIFICA SE TEM ALGUMA COISA PARA ATUALIZAR
            if (formData.length === 0) {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.msgWarn('WEB [200]: Nenhuma ação foi realizada, pois os itens já estão com o status solicitado.', 'success')

              // FECHA A TELA
              this.pcoEditarVariosFechar(true)
            } else {
              // FAZ A ATUALIZAÇÃO DOS REGISTROS
              this.$store.state.comunicaAPI('/con-processo', 'PUT', { lot: formData }, (retorno) => {
                this.$store.state.TRATAR_RET_LOT_API(retorno, () => { this.pcoEditarVariosFechar(true) })
              }, this.pcoEditarVariosSetarStatusGeral, (apiValid, apiStatus) => {
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, {}, true, () => {
                  // SETA O VALOR RECEBIDO
                  this.$set(this.campos.pco_item, 'value', '')
  
                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.time = new Date().getTime()
                })
              })
            }
          }, where)
        }
      }
    }
  }
</script>
